import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog"
import { cn } from "@/lib/utils"
import { VisuallyHidden } from "@radix-ui/react-visually-hidden"
import React from "react"

export default function ModalComp({
  isOpen,
  onOpenChange,
  title,
  description,
  trigger,
  children,
  hiddenTitle = false,
  hiddenDescription = false,
  className,
}: {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  description?: string
  children: React.ReactNode
  trigger?: React.ReactNode
  hiddenTitle?: boolean
  hiddenDescription?: boolean
  className?: string
}) {
  const modalTitle = <DialogTitle>{title}</DialogTitle>
  const modalDescription = <DialogDescription>{description}</DialogDescription>

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      {trigger && (
        <DialogTrigger asChild onClick={() => onOpenChange(true)}>
          {trigger}
        </DialogTrigger>
      )}
      {isOpen && (
        <DialogContent className={cn("max-h-[90vh] overflow-y-auto", className)}>
          <DialogHeader>
            {hiddenTitle ? <VisuallyHidden>{modalTitle}</VisuallyHidden> : modalTitle}
            {hiddenDescription ? <VisuallyHidden>{modalDescription}</VisuallyHidden> : modalDescription}
          </DialogHeader>
          {children}
        </DialogContent>
      )}
    </Dialog>
  )
}
